import Axios from 'axios';

import {
    SET_ARCHIVE_STATUS,
    SET_SOLD_STATUS,
    SET_JOB_STATUS,
    SET_PROJECT_TOKEN,
} from './constants';

export const setArchiveStatus = archiveStatus => ({
    type: SET_ARCHIVE_STATUS,
    archiveStatus,
});
export const setSoldStatus = soldStatus => ({
    type: SET_SOLD_STATUS,
    soldStatus,
});
export const setJobStatus = jobStatus => ({
    type: SET_JOB_STATUS,
    jobStatus,
});
export const setProjectToken = projectToken => ({
    type: SET_PROJECT_TOKEN,
    projectToken,
});

export const createProjectToken = (authToken, projectId) => (dispatch) => {
    const optionAxios = {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authToken}`,
        },
    };
    const payload =
    {
        id: `${projectId}`,
    };
    Axios
        .post('/v1/project/token', payload, optionAxios)
        .then((res) => {
            dispatch(setProjectToken(res.data.token));
        }).catch(() => {
            dispatch(setProjectToken('There was a problem creating a the token for this project.'));
        });
};
export const deleteProjectToken = (authToken, projectId) => (dispatch) => {
    const optionAxios = {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authToken}`,
        },
    };
    Axios
        .delete(`/v1/project/token/${projectId}`, optionAxios)
        .then(() => {
            dispatch(setProjectToken(null));
        }).catch((res) => {
            dispatch(setProjectToken('There was a problem deleting the token.'));
        });
};



// WEBPACK FOOTER //
// ./src/containers/common/projectstatus/actions.js